module.exports = __webpack_public_path__ + "img/5.66ad4226.png";